// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import LineChartSvg from '@rsuite/icon-font/lib/charts/LineChart';
var LineChart = createSvgIcon({
  as: LineChartSvg,
  ariaLabel: 'line chart',
  category: 'charts',
  displayName: 'LineChart'
});
export default LineChart;